/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsstatement1Inputs */

const en_earningsstatement1 = /** @type {(inputs: Earningsstatement1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open statement`)
};

const de_earningsstatement1 = /** @type {(inputs: Earningsstatement1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrechnung öffnen`)
};

/**
* | output |
* | --- |
* | "Open statement" |
*
* @param {Earningsstatement1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsstatement1 = /** @type {((inputs?: Earningsstatement1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsstatement1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsstatement1(inputs)
	return de_earningsstatement1(inputs)
});
export { earningsstatement1 as "earningsStatement" }